<template>
  <div
    :class="[baseClass, customClass]"
    class="lp-comment"
  >
    <div class="lp-comment-header">
      <div
        class="lp-comment-avatar"
        :style="`background-color: ${data.avatarColor || '#410b57'}`"
      >
        {{ data.avatar }}
      </div>
      <div class="lp-comment-title">
        <h5>
          {{ data.title }}
        </h5>
        <div class="lp-comment-stars">
          <img
            src="@/assets/images/lps/star.png"
            alt="star"
          >
          <img
            src="@/assets/images/lps/star.png"
            alt="star"
          >
          <img
            src="@/assets/images/lps/star.png"
            alt="star"
          >
          <img
            src="@/assets/images/lps/star.png"
            alt="star"
          >
          <img
            src="@/assets/images/lps/star.png"
            alt="star"
          >
        </div>
      </div>
    </div>
    <div class="lp-comment-subheader">
      <div class="lp-comment-name">
        {{ data.name }} - {{ data.date }}
      </div>
    </div>
    <div class="lp-comment-content">
      {{ data.comment }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LpUserCard',
  props: {
    customClass: {
      type: String,
      required: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baseClass: null,
    }
  },
}
</script>
